import React from 'react';
import { DataGrid as DataGridContainer } from '@ihsm/ui-shared';
import { CustomDataGridProps } from './types';

export function ReactDataGrid<T>({
  columns,
  data,
  fallback: FallBack,
  ...props
}: React.PropsWithChildren<CustomDataGridProps<T>>): JSX.Element {
  if (!data || data.length <= 0) {
    if (FallBack) {
      return <FallBack />;
    }

    return <p>No Data</p>;
  }

  return <DataGridContainer columns={columns} data={data} {...props} />;
}
